export enum ScheduleCalendarSlotsListTestID {
    Column = 'ScheduleCalendarSlotsListTestID.Column',
    Row = 'ScheduleCalendarSlotsListTestID.Row',
    TimeSlot = 'ScheduleCalendarSlotTestID.TimeSlot',
}
